import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { CodeColumnLayout, CodeLayout, CodeViewer, MermaidViewer, CodeDescription, WhiteColumnLayout, LayoutColumn, WhiteLayout } from "netcompany-mdx-slide";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const LayoutStep = makeShortcode("LayoutStep");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <WhiteLayout title={"The case study"} mdxType="WhiteLayout">
      <h3>{`Polymorphism - The next level of Abstraction`}</h3>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`The word itself indicates the meaning as `}<strong parentName="p">{`poly`}</strong>{` means `}<em parentName="p">{`many`}</em>{` and `}<strong parentName="p">{`morphism`}</strong>{` means `}<em parentName="p">{`types`}</em>{`.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Polymorphism is a property through which any message can be sent to objects of multiple classes, and every object has the tendency to respond in an appropriate way depending on the class properties.`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`This means that polymorphism is the method in an OOP language that does different things depending on the class of the object which calls it.`}</p>
        </li>
      </ul>
    </WhiteLayout>
    <hr></hr>
    <CodeColumnLayout title={"The case study"} subTitle={"Polymorphism"} sizes={[4, 4]} mdxType="CodeColumnLayout">
  
  <LayoutStep mdxType="LayoutStep">
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "8,23:46 file=../src/main/java/com/netcompany/core/AbstractMenu.java showNumbers zoomIn=1.3 skipRows=9:21",
            "8,23:46": true,
            "file": "../src/main/java/com/netcompany/core/AbstractMenu.java",
            "showNumbers": true,
            "zoomIn": "1.3",
            "skipRows": "9:21"
          }}>{`package com.netcompany.core;

import java.util.ArrayList;
import java.util.List;
import java.util.Scanner;
import java.util.regex.Pattern;

public abstract class AbstractMenu implements Menu {
    private static final Pattern numericPattern = Pattern.compile("^\\\\d+$");
    protected ConsoleContext appCtx;
    protected List<MenuItem> menuItems;

    public AbstractMenu(ConsoleContext appCtx) {
        this.appCtx = appCtx;
        this.menuItems = new ArrayList<>();
    }

    @Override
    public List<MenuItem> getMenuItems() {
        return this.menuItems;
    }

    @Override
    public void launch() {
        String userChoise = null;
        int index;
        int userChoiseInt = 0;
        Scanner scanner = this.appCtx.getScanner();
        do {
            System.out.println(this.getMenuHeader());
            index = 1;
            for (MenuItem menuItem : this.getMenuItems()) {
                System.out.println(String.format("%d. %s", index, menuItem.getItemName()));
                index++;
            }
            System.out.println(String.format("0. %s", this.getBackItemName()));
            do {
                System.out.print(this.getSelectInstruction());
                userChoise = scanner.nextLine();
            } while (!this.checkUserChoise(userChoise));
            userChoiseInt = Integer.parseInt(userChoise);
            if (userChoiseInt != 0) {
                this.launchMenuItem(userChoiseInt - 1);
            }
        } while (userChoiseInt != 0);
    }

    protected String getSelectInstruction() {
        return "Enter your choise: ";
    }

    protected void launchMenuItem(int index) {
        this.getMenuItems()
                .get(index)
                .launch();
    }

    private boolean checkUserChoise(String userChoise) {
        if (!numericPattern.matcher(userChoise).find()) {
            System.out.println("Invalid choise: the choise must be integer and follow instruction above.");
            return false;
        }
        int userChoiseValue = Integer.parseInt(userChoise);
        if (userChoiseValue < 0 || userChoiseValue > this.getMenuItems().size()) {
            System.out.println(
                    String.format("Invalid choise: the choise must between 0 and %d", this.getMenuItems().size()));
            return false;
        }
        return true;
    }
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "13,14,21:25 file=../src/main/java/com/netcompany/commonFeature/AbstractSavedBalanceSheetFeature.java showNumbers zoomIn=1.6 skipRows=15:19",
            "13,14,21:25": true,
            "file": "../src/main/java/com/netcompany/commonFeature/AbstractSavedBalanceSheetFeature.java",
            "showNumbers": true,
            "zoomIn": "1.6",
            "skipRows": "15:19"
          }}>{`package com.netcompany.commonFeature;

import java.util.List;

import com.netcompany.core.AbstractMenu;
import com.netcompany.core.ConsoleContext;
import com.netcompany.core.MenuItem;
import com.netcompany.entity.BalanceSheet;
import com.netcompany.service.GpaBalancingService;
import com.netcompany.service.impl.GpaBalancingServiceImpl;
import com.netcompany.utils.StringUtils;

public abstract class AbstractSavedBalanceSheetFeature 
        extends AbstractMenu implements MenuItem {
    protected GpaBalancingService gpaBalancingService = new GpaBalancingServiceImpl();

    public AbstractSavedBalanceSheetFeature(ConsoleContext consoleContext) {
        super(consoleContext);
    }

    @Override
    public void launch() {
        this.loadMenuItems();
        super.launch();
    }

    protected void loadMenuItems() {
        this.menuItems.clear();
        List<BalanceSheet> savedSheets = this.gpaBalancingService.getSavedBalanceSheets();
        for (BalanceSheet balanceSheet : savedSheets) {
            this.menuItems.add(new BalanceSheetMenuItem(balanceSheet));
        }
    }

    @Override
    public String getMenuHeader() {
        return "List of saved balance sheets\\n" +
                "            ----            \\n";
    }

    @Override
    protected void launchMenuItem(int index) {
        MenuItem menuItem = this.menuItems.get(index);
        if (menuItem instanceof BalanceSheetMenuItem) {
            BalanceSheet balanceSheet = ((BalanceSheetMenuItem) menuItem).getBalanceSheet();
            balanceSheet = this.gpaBalancingService.findBalanceSheetWithCreatedTime(balanceSheet.getCreatedOn());
            this.launchBalanceSheetFeature(balanceSheet);
        }
    }

    protected abstract void launchBalanceSheetFeature(BalanceSheet balanceSheet);

    private class BalanceSheetMenuItem implements MenuItem {
        private BalanceSheet balanceSheet;

        public BalanceSheetMenuItem(BalanceSheet balanceSheet) {
            this.balanceSheet = balanceSheet;
        }

        @Override
        public String getItemName() {
            return StringUtils.toEpocTimeString(this.balanceSheet.getCreatedOn());
        }

        @Override
        public void launch() {
        }

        public BalanceSheet getBalanceSheet() {
            return balanceSheet;
        }
    }

}
`}</code></pre>
  </LayoutStep>
  <LayoutStep mdxType="LayoutStep">
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "8,23:46 file=../src/main/java/com/netcompany/core/AbstractMenu.java showNumbers zoomIn=1.3 skipRows=9:21",
            "8,23:46": true,
            "file": "../src/main/java/com/netcompany/core/AbstractMenu.java",
            "showNumbers": true,
            "zoomIn": "1.3",
            "skipRows": "9:21"
          }}>{`package com.netcompany.core;

import java.util.ArrayList;
import java.util.List;
import java.util.Scanner;
import java.util.regex.Pattern;

public abstract class AbstractMenu implements Menu {
    private static final Pattern numericPattern = Pattern.compile("^\\\\d+$");
    protected ConsoleContext appCtx;
    protected List<MenuItem> menuItems;

    public AbstractMenu(ConsoleContext appCtx) {
        this.appCtx = appCtx;
        this.menuItems = new ArrayList<>();
    }

    @Override
    public List<MenuItem> getMenuItems() {
        return this.menuItems;
    }

    @Override
    public void launch() {
        String userChoise = null;
        int index;
        int userChoiseInt = 0;
        Scanner scanner = this.appCtx.getScanner();
        do {
            System.out.println(this.getMenuHeader());
            index = 1;
            for (MenuItem menuItem : this.getMenuItems()) {
                System.out.println(String.format("%d. %s", index, menuItem.getItemName()));
                index++;
            }
            System.out.println(String.format("0. %s", this.getBackItemName()));
            do {
                System.out.print(this.getSelectInstruction());
                userChoise = scanner.nextLine();
            } while (!this.checkUserChoise(userChoise));
            userChoiseInt = Integer.parseInt(userChoise);
            if (userChoiseInt != 0) {
                this.launchMenuItem(userChoiseInt - 1);
            }
        } while (userChoiseInt != 0);
    }

    protected String getSelectInstruction() {
        return "Enter your choise: ";
    }

    protected void launchMenuItem(int index) {
        this.getMenuItems()
                .get(index)
                .launch();
    }

    private boolean checkUserChoise(String userChoise) {
        if (!numericPattern.matcher(userChoise).find()) {
            System.out.println("Invalid choise: the choise must be integer and follow instruction above.");
            return false;
        }
        int userChoiseValue = Integer.parseInt(userChoise);
        if (userChoiseValue < 0 || userChoiseValue > this.getMenuItems().size()) {
            System.out.println(
                    String.format("Invalid choise: the choise must between 0 and %d", this.getMenuItems().size()));
            return false;
        }
        return true;
    }
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "12,35:44 file=../src/main/java/com/netcompany/menu/newBalanceSheetMenu/NewBalanceSheetMenu.java showNumbers zoomIn=1.4 skipRows=13:33",
            "12,35:44": true,
            "file": "../src/main/java/com/netcompany/menu/newBalanceSheetMenu/NewBalanceSheetMenu.java",
            "showNumbers": true,
            "zoomIn": "1.4",
            "skipRows": "13:33"
          }}>{`package com.netcompany.menu.newBalanceSheetMenu;

import com.netcompany.commonFeature.AbstractBalanceSheetFeature;
import com.netcompany.commonFeature.ShowBalanceSheetDetailFeature;
import com.netcompany.core.AbstractMenu;
import com.netcompany.core.ConsoleContext;
import com.netcompany.core.MenuItem;
import com.netcompany.entity.BalanceSheet;
import com.netcompany.service.GpaBalancingService;
import com.netcompany.service.impl.GpaBalancingServiceImpl;

public class NewBalanceSheetMenu extends AbstractMenu implements MenuItem {
    private GpaBalancingService gpaBalancingService = new GpaBalancingServiceImpl();
    private BalanceSheet currentBalanceSheet;
    private UpdateBalancingExpectedGpaFeature updateBalancingExpectedGpaFeature;
    private ShowBalanceSheetDetailFeature showBalanceSheetDetailFeature;

    public NewBalanceSheetMenu(
            ConsoleContext appCtx) {
        super(appCtx);
        this.updateBalancingExpectedGpaFeature = new UpdateBalancingExpectedGpaFeature(appCtx);
        this.showBalanceSheetDetailFeature = new ShowBalanceSheetDetailFeature(appCtx);
        this.menuItems.add(updateBalancingExpectedGpaFeature);
        this.menuItems.add(new AdjustBalanceSheetFeature(appCtx));
        this.menuItems.add(new CleanBalanceSheetAdjustmentFeature(appCtx));
        this.menuItems.add(new ResetBalanceSheetFeature(appCtx));
        this.menuItems.add(new PersistBalanceSheetFeature(appCtx));
    }

    @Override
    public String getItemName() {
        return "Create grade balance sheet";
    }

    @Override
    public void launch() {
        this.currentBalanceSheet = this.gpaBalancingService.createNewBalanceSheet(-1);
        this.updateMenuItemContext();
        updateBalancingExpectedGpaFeature.launch();
        Float expectedGpa = this.currentBalanceSheet.getExpectedGpa();
        if (expectedGpa != -1) {
            super.launch();
        }
    }

    private void updateMenuItemContext() {
        this.showBalanceSheetDetailFeature.setCurrentBalanceSheet(currentBalanceSheet);
        this.updateBalancingExpectedGpaFeature.setCurrentBalanceSheet(currentBalanceSheet);
        for (MenuItem menuItem : menuItems) {
            if (menuItem instanceof AbstractBalanceSheetFeature) {
                ((AbstractBalanceSheetFeature) menuItem).setCurrentBalanceSheet(currentBalanceSheet);
            }
        }
    }

    @Override
    public String getBackItemName() {
        return "Back to main menu";
    }

    @Override
    public String getMenuHeader() {
        return "Create balance sheet\\n" +
                this.showBalanceSheetDetailFeature.getBalanceSheetDetailString();
    }

}
`}</code></pre>
  </LayoutStep>
    </CodeColumnLayout>
    <hr></hr>
    <CodeColumnLayout title={"The case study"} subTitle={"Polymorphism"} sizes={[3, 4]} mdxType="CodeColumnLayout">
  <LayoutStep mdxType="LayoutStep">
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "10,19:28 file=../src/main/java/com/netcompany/menu/MainMenu.java showNumbers zoomIn=1.3 skipRows=11:18",
            "10,19:28": true,
            "file": "../src/main/java/com/netcompany/menu/MainMenu.java",
            "showNumbers": true,
            "zoomIn": "1.3",
            "skipRows": "11:18"
          }}>{`package com.netcompany.menu;

import com.netcompany.core.AbstractMenu;
import com.netcompany.core.ConsoleContext;
import com.netcompany.menu.manageBalanceSheet.ManageBalanceSheetMenu;
import com.netcompany.menu.manageCourse.ManageCourseMenu;
import com.netcompany.menu.manageGrade.ManageGradeMenu;
import com.netcompany.menu.newBalanceSheetMenu.NewBalanceSheetMenu;

public class MainMenu extends AbstractMenu {
    public MainMenu(ConsoleContext appCtx) {
        super(appCtx);
        this.menuItems.add(new ManageCourseMenu(appCtx));
        this.menuItems.add(new ManageGradeMenu(appCtx));
        this.menuItems.add(new NewBalanceSheetMenu(appCtx));
        this.menuItems.add(new ManageBalanceSheetMenu(appCtx));
    }

    @Override
    public String getBackItemName() {
        return "Exit";
    }

    @Override
    public String getMenuHeader() {
        return "GPA Self-tracking application\\n" +
                "          - Powered by Dazzle\\n";
    }
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "8,23:46 file=../src/main/java/com/netcompany/core/AbstractMenu.java showNumbers zoomIn=1.3,30 skipRows=9:22",
            "8,23:46": true,
            "file": "../src/main/java/com/netcompany/core/AbstractMenu.java",
            "showNumbers": true,
            "zoomIn": "1.3,30",
            "skipRows": "9:22"
          }}>{`package com.netcompany.core;

import java.util.ArrayList;
import java.util.List;
import java.util.Scanner;
import java.util.regex.Pattern;

public abstract class AbstractMenu implements Menu {
    private static final Pattern numericPattern = Pattern.compile("^\\\\d+$");
    protected ConsoleContext appCtx;
    protected List<MenuItem> menuItems;

    public AbstractMenu(ConsoleContext appCtx) {
        this.appCtx = appCtx;
        this.menuItems = new ArrayList<>();
    }

    @Override
    public List<MenuItem> getMenuItems() {
        return this.menuItems;
    }

    @Override
    public void launch() {
        String userChoise = null;
        int index;
        int userChoiseInt = 0;
        Scanner scanner = this.appCtx.getScanner();
        do {
            System.out.println(this.getMenuHeader());
            index = 1;
            for (MenuItem menuItem : this.getMenuItems()) {
                System.out.println(String.format("%d. %s", index, menuItem.getItemName()));
                index++;
            }
            System.out.println(String.format("0. %s", this.getBackItemName()));
            do {
                System.out.print(this.getSelectInstruction());
                userChoise = scanner.nextLine();
            } while (!this.checkUserChoise(userChoise));
            userChoiseInt = Integer.parseInt(userChoise);
            if (userChoiseInt != 0) {
                this.launchMenuItem(userChoiseInt - 1);
            }
        } while (userChoiseInt != 0);
    }

    protected String getSelectInstruction() {
        return "Enter your choise: ";
    }

    protected void launchMenuItem(int index) {
        this.getMenuItems()
                .get(index)
                .launch();
    }

    private boolean checkUserChoise(String userChoise) {
        if (!numericPattern.matcher(userChoise).find()) {
            System.out.println("Invalid choise: the choise must be integer and follow instruction above.");
            return false;
        }
        int userChoiseValue = Integer.parseInt(userChoise);
        if (userChoiseValue < 0 || userChoiseValue > this.getMenuItems().size()) {
            System.out.println(
                    String.format("Invalid choise: the choise must between 0 and %d", this.getMenuItems().size()));
            return false;
        }
        return true;
    }
}
`}</code></pre>
  </LayoutStep>
  <LayoutStep mdxType="LayoutStep">
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "10,19:28 file=../src/main/java/com/netcompany/menu/MainMenu.java showNumbers skipRows=11:18 zoomIn=1.3",
            "10,19:28": true,
            "file": "../src/main/java/com/netcompany/menu/MainMenu.java",
            "showNumbers": true,
            "skipRows": "11:18",
            "zoomIn": "1.3"
          }}>{`package com.netcompany.menu;

import com.netcompany.core.AbstractMenu;
import com.netcompany.core.ConsoleContext;
import com.netcompany.menu.manageBalanceSheet.ManageBalanceSheetMenu;
import com.netcompany.menu.manageCourse.ManageCourseMenu;
import com.netcompany.menu.manageGrade.ManageGradeMenu;
import com.netcompany.menu.newBalanceSheetMenu.NewBalanceSheetMenu;

public class MainMenu extends AbstractMenu {
    public MainMenu(ConsoleContext appCtx) {
        super(appCtx);
        this.menuItems.add(new ManageCourseMenu(appCtx));
        this.menuItems.add(new ManageGradeMenu(appCtx));
        this.menuItems.add(new NewBalanceSheetMenu(appCtx));
        this.menuItems.add(new ManageBalanceSheetMenu(appCtx));
    }

    @Override
    public String getBackItemName() {
        return "Exit";
    }

    @Override
    public String getMenuHeader() {
        return "GPA Self-tracking application\\n" +
                "          - Powered by Dazzle\\n";
    }
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java",
            "metastring": "8,30[32:52],36[60:77] file=../src/main/java/com/netcompany/core/AbstractMenu.java showNumbers zoomIn=1.5,30  skipRows=9:22",
            "8,30[32:52],36[60:77]": true,
            "file": "../src/main/java/com/netcompany/core/AbstractMenu.java",
            "showNumbers": true,
            "zoomIn": "1.5,30",
            "": true,
            "skipRows": "9:22"
          }}>{`package com.netcompany.core;

import java.util.ArrayList;
import java.util.List;
import java.util.Scanner;
import java.util.regex.Pattern;

public abstract class AbstractMenu implements Menu {
    private static final Pattern numericPattern = Pattern.compile("^\\\\d+$");
    protected ConsoleContext appCtx;
    protected List<MenuItem> menuItems;

    public AbstractMenu(ConsoleContext appCtx) {
        this.appCtx = appCtx;
        this.menuItems = new ArrayList<>();
    }

    @Override
    public List<MenuItem> getMenuItems() {
        return this.menuItems;
    }

    @Override
    public void launch() {
        String userChoise = null;
        int index;
        int userChoiseInt = 0;
        Scanner scanner = this.appCtx.getScanner();
        do {
            System.out.println(this.getMenuHeader());
            index = 1;
            for (MenuItem menuItem : this.getMenuItems()) {
                System.out.println(String.format("%d. %s", index, menuItem.getItemName()));
                index++;
            }
            System.out.println(String.format("0. %s", this.getBackItemName()));
            do {
                System.out.print(this.getSelectInstruction());
                userChoise = scanner.nextLine();
            } while (!this.checkUserChoise(userChoise));
            userChoiseInt = Integer.parseInt(userChoise);
            if (userChoiseInt != 0) {
                this.launchMenuItem(userChoiseInt - 1);
            }
        } while (userChoiseInt != 0);
    }

    protected String getSelectInstruction() {
        return "Enter your choise: ";
    }

    protected void launchMenuItem(int index) {
        this.getMenuItems()
                .get(index)
                .launch();
    }

    private boolean checkUserChoise(String userChoise) {
        if (!numericPattern.matcher(userChoise).find()) {
            System.out.println("Invalid choise: the choise must be integer and follow instruction above.");
            return false;
        }
        int userChoiseValue = Integer.parseInt(userChoise);
        if (userChoiseValue < 0 || userChoiseValue > this.getMenuItems().size()) {
            System.out.println(
                    String.format("Invalid choise: the choise must between 0 and %d", this.getMenuItems().size()));
            return false;
        }
        return true;
    }
}
`}</code></pre>
  </LayoutStep>
    </CodeColumnLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      